import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-field-ok-ticketcobitkat-list-view',
  imports: [],
  templateUrl: './ticketcobitkat.list-view.html',
  styleUrls: ['./ticketcobitkat.list-view.css'],
})
export class TicketcobitkatListView implements FieldOkItemComponent<any> {
  readonly item = input<any>();
}
